import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromReview from './reducers/review.reducer';
import { EffectsModule } from '@ngrx/effects';
import { ReviewEffects } from './effects/review.effects';
import { ReviewService } from './services/review.service';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(fromReview.reviewFeatureKey, fromReview.reducer),
    EffectsModule.forFeature([ReviewEffects])
  ],
  providers: [ReviewService]
})
export class ReviewStoreModule { }
